import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpCommonService } from '@shared/services/http-common.service';
import { GenericHttpResponse } from '@shared/services/interfaces/generic-http-response.interface';
import { Aspiracion } from '../../agendamientos/aspiraciones/aspiraciones.interface';
import { CultivoEmbrionario } from '../cultivos/cultivos.interface';

/** Una fila del historial: la donante × toro en un OPU, con su FIV y su cultivo. */
export interface FilaHistorialApi extends Aspiracion {
  agendamiento: {
    id: number;
    fecha: string;
    estado_codigo: string | null;
    establecimiento: string | null;
  };
  fiv: { id: number; pajuela: string | null; tecnica: string | null; dosis_consumidas: number } | null;
  cultivo: CultivoEmbrionario | null;
}

export interface HistorialPive {
  anio: number | null;
  anios: number[];
  filas: FilaHistorialApi[];
}

@Injectable({ providedIn: 'root' })
export class PiveHistorialService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  historial(clienteId: number, anio?: number | null): Observable<GenericHttpResponse<HistorialPive>> {
    const url = this.httpCommonService.makeUrl('/labs/pive/historial', {
      cli_cliente_id: clienteId,
      ...(anio ? { anio } : {}),
    });
    return this.http.get<GenericHttpResponse<HistorialPive>>(url);
  }
}
